import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { arrayOf, func, shape } from 'prop-types'
import { useMemo, useState } from 'react'
import styled from 'styled-components'
import { string } from 'yup/lib/locale'
import { Collapse } from '../../../../components/Collapse'
import { Heading, HeadingSize } from '../../../../components/Ui-Kits/Text'
import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons'
import { useQuery } from '../../../../hooks/query/useQuery'
import { useSetQuery } from '../../../../hooks/query/useSetQuery'
import { FilterItem } from './FilterItem'

export const Filter = ({ options, title, name, hasProductsForFilter }) => {
  const [open, setOpen] = useState()
  const toggleOpen = () => setOpen(open => !open)
  const { [name]: values = [] } = useQuery()
  const setQuery = useSetQuery()

  const onCheckboxChange = e => {
    const val = e.target.value

    if (!e.target.checked) return setQuery({ [name]: values.filter(item => item != val) })

    setQuery({ [name]: [...values, val] })
  }

  const filteredOptions = useMemo(
    () => options.filter(({ value }) => !!hasProductsForFilter(name, ['' + value])),
    [options, hasProductsForFilter, name]
  )

  if (!filteredOptions.length) return null

  return (
    <Wrap>
      <HeadingWrap onClick={toggleOpen}>
        <Heading color="primary" size={HeadingSize.SMALLEST} mt={0} mb={0}>
          {title}
        </Heading>
        <Icon icon={open ? faAngleUp : faAngleDown} />
      </HeadingWrap>
      <Collapse open={open}>
        <CheckboxesWrap>
          {filteredOptions.map(({ label, value, children = [] }) => (
            <FilterItem
              label={label}
              value={value}
              key={value}
              onChange={onCheckboxChange}
              checked={!!values.find(item => item == value)}
              childrenOptions={children}
              values={values}
            />
          ))}
        </CheckboxesWrap>
      </Collapse>
    </Wrap>
  )
}

Filter.propTypes = {
  options: arrayOf(
    shape({
      label: string.isRequired,
      value: string.isRequired,
    })
  ).isRequired,
  title: string.isRequired,
  name: string.isRequired,
  hasProductsForFilter: func,
}

const Wrap = styled.div`
  margin-bottom: 2rem;
  &:last-child {
    margin-bottom: 0;
  }
`
const HeadingWrap = styled.div`
  display: inline-flex;
  cursor: pointer;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-start;
  user-select: none;
`
const Icon = styled(FontAwesomeIcon)`
  color: var(--color-primary);
  font-size: 0.625rem;
`

const CheckboxesWrap = styled.div`
  padding-top: 0.5rem;
  max-height: 400px;
  overflow: auto;
`
